import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Row } from 'further-ui/components/Layout';

const PreviousButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'visible',
})<{ visible: boolean }>(({ visible }) => ({
  visibility: visible ? 'visible' : 'hidden',
}));

type Props = {
  onPrevious?: () => void;
  onNext?: () => void;
  nextLabel?: string;
  isNextLoading?: boolean;
  isNextDisabled?: boolean;
  isPreviousDisabled?: boolean;
};

const PartnerTransferActionBar: React.FC<Props> = ({
  onPrevious,
  onNext,
  nextLabel = 'Save and continue',
  isNextLoading = false,
  isNextDisabled = false,
  isPreviousDisabled = false,
}) => (
  <Row fullWidth justify="space-between">
    <PreviousButton
      size="large"
      variant="outlined"
      onClick={onPrevious}
      disabled={isPreviousDisabled}
      visible={!!onPrevious}
    >
      Previous step
    </PreviousButton>
    {onNext && (
      <Button
        size="large"
        variant="contained"
        onClick={onNext}
        loading={isNextLoading}
        disabled={isNextDisabled}
      >
        {nextLabel}
      </Button>
    )}
  </Row>
);

export default PartnerTransferActionBar;
